import { Box, Container, Grid, Typography } from "@material-ui/core";
import { assetIds, ThemedAsset } from "nemuru-components";
import React, { useContext } from "react";
import ResponsiveLayout from "./ResponsiveLayout";
import { useTheme } from "@material-ui/styles";
import Text from "./Text";
import ResponsiveDialog from "./ResponsiveDialog";
import { ProcessContext } from "../../../contexts/ProcessContext";
import MainButton from "./MainButton";

export default function RetriableErrorMessage({ message, action }) {
  const { palette } = useTheme();
  const { dispatch } = useContext(ProcessContext);

  const { requestPayload } = action;

  const retryDispatchAndResetContextError = () => {
    const failedRequest = action?.type?.replace("_REJECTED", "");

    dispatch({
      type: "RESET_PROCESS_RETRIABLE_ERROR",
    });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
    dispatch({
      type: `${failedRequest}`,
      payload: requestPayload,
    });
  };

  return (
    <ResponsiveDialog
      PaperProps={{
        "aria-label": "Retriable error message dialog",
      }}
      className={"appear-anim"}
      displayCondition={true}
      fullScreenCondition={true}
      open={message !== null || action !== null}
    >
      <Container style={{ padding: "1rem 1rem", height: "100%" }}>
        <ResponsiveLayout>
          <Box />

          <Box
            mt={4}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            className="appear-anim"
          >
            <ThemedAsset
              id={assetIds.ICON_FAIL}
              width={50}
              height={50}
              style={{ color: palette.error.main }}
            />
            <Grid
              container
              display="flex"
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ paddingTop: 20 }}
            >
              <Typography
                color={palette.text.title}
                variant={"h6"}
                className={"mb-1 transition-all"}
              >
                <strong>
                  <Text tId={"OOPS_SOMETHING_WENT_WRONG"} />
                </strong>
              </Typography>
              <Typography
                variant={"body2"}
                className={"mb-3 transition-all"}
                style={{
                  color: palette.text.primary,
                  textAlign: "left",
                  overflow: "hidden",
                  whiteSpace: "break-spaces",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {message}
              </Typography>
            </Grid>
          </Box>
          <Box />
          {action && (
            <Box>
              <MainButton
                fullWidth
                onClick={() => {
                  retryDispatchAndResetContextError();
                }}
              >
                <Text tId={"RETRY"} />
              </MainButton>
            </Box>
          )}
        </ResponsiveLayout>
      </Container>
    </ResponsiveDialog>
  );
}
